<template>
  <DxSelectBox
    :ref="dropDownBoxRefName"
    :drop-down-options="dropDownOptions"
    :data-source="dataSource"
    :value.sync="currentValue"
    display-expr="CompanyName"
    value-expr="CompanyName"
    :search-expr="['CustomerCode', 'CompanyName']"
    search-mode="contains"
    :search-enabled="true"
    :on-item-click="onItemClicked"
    item-template="delivery-address-template"
    @focus-in="focusIn"
    :disabled="disabled"
    :placeholder="''"
    :on-value-changed="onAddressChanged"
  >
    <template #delivery-address-template="{ data }">
      <div class="custom-auto-complete data-grid">
        <span class="auto-complete-primary">
          {{ data.CompanyName }}
        </span>
        <div class="auto-complete-secondary no-padding">
          <span v-if="data.PhysicalAddressStreetLine1 != ''">
            {{ data.PhysicalAddressStreetLine1 }}
          </span>
          <span v-if="data.PhysicalAddressStreetLine2 != ''">{{
            data.PhysicalAddressStreetLine2
          }}</span>
          <span v-if="data.PhysicalAddressSuburb != ''">{{
            data.PhysicalAddressSuburb
          }}</span>
          <span v-if="data.PhysicalAddressState != ''">{{
            data.PhysicalAddressState
          }}</span>
          <span v-if="data.PhysicalAddressPostcode != ''">{{
            data.PhysicalAddressPostcode
          }}</span>
        </div>
      </div>
    </template>
  </DxSelectBox>
</template>
<script>
import DxSelectBox from "devextreme-vue/select-box";

const dropDownBoxRefName = "dropDownBoxRef";

export default {
  components: {
    DxSelectBox,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onItemClick: {
      type: Function,
      default: () => function() {},
    },
    dataSource: {
      type: Array,
      default: () => {},
    },
    cellInfo: {
      type: Object,
      default: () => {},
    },
    focusIn: {
      type: Function,
      default: () => function() {},
    },
    onValueChanged: {
      type: Function,
      default: () => function() {},
    },
  },
  data() {
    return {
      currentValue: this.value,
      dropDownOptions: { width: "auto" },
      dropDownBoxRefName,
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    onAddressChanged(valueChangedArgs) {
      this.onValueChanged(valueChangedArgs, this.cellInfo);
    },
    onItemClicked(selectionChangedArgs) {
      this.currentValue = selectionChangedArgs.itemData.CompanyName;
      this.onItemClick(selectionChangedArgs, this.cellInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
.gc-dropdown-list-item {
  font-size: 14px;
}
</style>
